
















import { UserModule } from "@/store/modules/me-user.store";
import { Component, Vue } from "vue-property-decorator";
import ThgBillingCreateNewBillingManual from "./ThgBillingCreateNewBillingManual.vue";

@Component({ components: { ThgBillingCreateNewBillingManual } })
export default class ThgBillingCreateNewDialog extends Vue {
  newBillingDialog = false;

  get isAdmin() {
    return UserModule.isAdmin;
  }

  onCreated() {
    this.newBillingDialog = false;
    this.$emit("refresh");
  }
}
